import React from "react";
import { Tooltip, TooltipProps } from "@rneui/themed";

const ControlledTooltip = ({ content, open, setOpenTooltip, ...props }) => {
  return (
    <Tooltip
      visible={open}
      onOpen={() => {
        setOpenTooltip(true);
      }}
      onClose={() => {
        setOpenTooltip(false);
      }}
      {...props}
      skipAndroidStatusBar={true}
    >
      {content()}
    </Tooltip>
  );
};

export default ControlledTooltip;
